import React, { useEffect } from "react";

export default function AboutPage({ 
  accent = "#115e32",
  pageTitle = "About | University of Creative Technology Chittagong",
}) {
	useEffect(() => {
		document.title = pageTitle;
	}, [pageTitle]);
  return (
    <div className="relative overflow-hidden">
      {/* ===== Hero Section ===== */}
      <section className="relative bg-gradient-to-r from-[#E6FAFE] via-[#D6F5FE] to-[#F0FCFF] py-20">
        {/* Decorative SVG */}
        <svg
          className="absolute top-0 left-0 w-full h-full opacity-10"
          xmlns="http://www.w3.org/2000/svg"
          preserveAspectRatio="none"
          viewBox="0 0 800 400"
        >
          <path
            d="M 0 200 Q 200 100 400 200 T 800 200 V 400 H 0 Z"
            fill="#016C94"
          />
          <circle cx="700" cy="100" r="80" fill="#1f6da8" opacity="0.4" />
          <circle cx="100" cy="350" r="50" fill="#016C94" opacity="0.4" />
        </svg>

        <div className="relative z-10 container mx-auto px-6 text-center">
          <h1 className="text-4xl md:text-5xl font-extrabold text-[#1f6da8] mb-4 animate-fadeInDown animate-bounce">
            About UCTC
          </h1>
          <p className="text-lg text-gray-700 max-w-3xl mx-auto animate-fadeInUp">
            University of Creative Technology, Chittagong (UCTC) – A vision-driven
            institution for innovation, technology, and excellence in higher
            education.
          </p>
        </div>
      </section>

      {/* ===== About Content ===== */}
      <section className="relative py-16 bg-white">
        <div className="container mx-auto px-6 grid md:grid-cols-2 gap-12 items-center">
          {/* Left Side Text */}
          <div className="space-y-6 animate-fadeInLeft">
            <h2 className="text-3xl font-bold text-[#016C94]">
              University of Creative Technology Chittagong
            </h2>
            <p className="text-gray-700 text-justify leading-relaxed">
              University of Creative Technology, Chittagong (UCTC) is one of the
              newest technology-based Government and UGC-approved private
              universities in Bangladesh. The credit for establishing this
              University goes to UCTC Trust (UCTCT), a non-political and
              non-profit voluntary organization founded in December 2015.
            </p>
            <p className="text-gray-700 text-justify leading-relaxed">
              On June 17, 2015, UGC inspected UCTC and later approved it on
              December 29, 2015, after careful evaluation among 180 project
              profiles. With the dream of being a world-class institution for
              teaching, research, innovation, and entrepreneurship, UCTC was
              founded to lead sustainable development in Bangladesh.
            </p>
            <p className="text-gray-700 text-justify leading-relaxed">
              Today, UCTC continues to welcome talented students nationwide to
              pursue higher studies with an innovative and technology-driven
              education system.
            </p>
          </div>

          {/* Right Side Image / SVG Illustration */}
          <div className="animate-fadeInRight">
            <img
              src="/img/logo.png"
              alt="UCTC Illustration"
              className="w-full max-w-md mx-auto drop-shadow-xl"
            />
          </div>
        </div>
      </section>

      {/* ===== Speciality Section ===== */}
      <section className="relative py-16 bg-gradient-to-b from-[#E6FAFE] to-[#F0FCFF]">
        <div className="container mx-auto px-6 text-center">
          <h2 className="text-3xl font-bold text-[#1f6da8] mb-8 animate-fadeInDown">
            Why Choose UCTC?
          </h2>

          <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-8 text-left">
            <div className="p-6 bg-white rounded-xl shadow-lg hover:shadow-2xl transition-all duration-500 animate-fadeInUp">
              <h3 className="font-semibold text-[#016C94] mb-2">
                🎓 Foreign Degree Holder Faculty
              </h3>
              <p className="text-gray-700 text-sm">
                Efficient and experienced foreign degree holder faculty members.
              </p>
            </div>

            <div className="p-6 bg-white rounded-xl shadow-lg hover:shadow-2xl transition-all duration-500 animate-fadeInUp">
              <h3 className="font-semibold text-[#016C94] mb-2">
                🔬 Practical & Research-Based
              </h3>
              <p className="text-gray-700 text-sm">
                A practical and research-oriented education system.
              </p>
            </div>

            <div className="p-6 bg-white rounded-xl shadow-lg hover:shadow-2xl transition-all duration-500 animate-fadeInUp">
              <h3 className="font-semibold text-[#016C94] mb-2">💻 Digital Facilities</h3>
              <p className="text-gray-700 text-sm">
                Fully digital academic and administrative facilities.
              </p>
            </div>

            <div className="p-6 bg-white rounded-xl shadow-lg hover:shadow-2xl transition-all duration-500 animate-fadeInUp">
              <h3 className="font-semibold text-[#016C94] mb-2">👩‍🎓 Female Classes</h3>
              <p className="text-gray-700 text-sm">
                Separate classes for female students with modern support.
              </p>
            </div>

            <div className="p-6 bg-white rounded-xl shadow-lg hover:shadow-2xl transition-all duration-500 animate-fadeInUp">
              <h3 className="font-semibold text-[#016C94] mb-2">🏛 Modern Facilities</h3>
              <p className="text-gray-700 text-sm">
                State-of-the-art modern campus facilities.
              </p>
            </div>
          </div>
        </div>
      </section>
	  
	  
      {/* ===== Vision & Mission ===== */}
      <section className="relative py-16 bg-gradient-to-b from-[#E6FAFE] to-[#F0FCFF]">
        <div className="container mx-auto px-6 space-y-12">
          <div className="text-center animate-fadeInDown">
            <h2 className="text-3xl font-bold text-[#1f6da8] mb-4">Vision</h2>
            <p className="text-gray-700 max-w-3xl mx-auto">
              To be a world class center of excellence in teaching, research,
              innovation and entrepreneurship for sustainable development.
            </p>
          </div>

          <div className="text-center animate-fadeInUp">
            <h2 className="text-3xl font-bold text-[#1f6da8] mb-4">Mission</h2>
            <p className="text-gray-700 max-w-4xl mx-auto leading-relaxed">
              UCTC will be leading technology based creative university of the
              country. UCTC strives to be the global benchmark institution with a
              highly qualified, talented and entrepreneurial workforce; innovative
              research; relevant academic programs, services; and technology and
              ideas to solve the greater challenges of the time. We will be able to
              contribute positively towards the social and national advancement of
              the country through the provision of knowledge based solutions to
              scientific, technological, economic and social challenges. We will
              fabricate our students with interactive and updated academic &
              extracurricular activities to flourish their creativity and make them
              proficient in their selected disciplines.
            </p>
          </div>
        </div>
      </section>

      {/* ===== Core Values ===== */}
      <section className="relative py-16 bg-white">
        <div className="container mx-auto px-6">
          <h2 className="text-3xl font-bold text-center text-[#016C94] mb-12">
            Core Values
          </h2>
          <div className="grid md:grid-cols-3 gap-8">
            {[
              {
                title: "ETHICS",
                text: "We value ethics and are committed to being ethical in our practices and services. Always nourish ethical values among staffs, teachers, and students.",
              },
              {
                title: "QUALITY",
                text: "We strive for excellence in everything we do. UCTC continuously seeks opportunities to improve further.",
              },
              {
                title: "LEADERSHIP",
                text: "We believe in leadership by setting examples for others through agile and prompt work processes.",
              },
              {
                title: "INNOVATION",
                text: "We empower individuals to think innovatively, remain curious, and value new ideas.",
              },
              {
                title: "DIVERSITY",
                text: "We respect opinions and ideas from all groups regardless of race, nationality, age, religion, or position.",
              },
              {
                title: "LIFELONG LEARNING",
                text: "We encourage lifelong learning so that individuals remain committed to upgrading themselves.",
              },
            ].map((value, i) => (
              <div
                key={i}
                className="p-6 bg-gradient-to-br from-[#D6F5FE] to-[#F0FCFF] rounded-xl shadow-md hover:shadow-xl transition duration-500 animate-fadeInUp"
              >
                <h3 className="text-xl font-semibold text-[#1f6da8] mb-3">
                  {value.title}
                </h3>
                <p className="text-gray-700 text-sm leading-relaxed">
                  {value.text}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
